import { render, staticRenderFns } from "./Galga.vue?vue&type=template&id=8dc2ba66&"
import script from "./Galga.vue?vue&type=script&lang=js&"
export * from "./Galga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports